'use strict';

var TemplateEntityV1beta3 = require('./TemplateEntityV1beta3.cjs.js');
var ScaffolderClient = require('./ScaffolderClient.cjs.js');



exports.isTemplateEntityV1beta3 = TemplateEntityV1beta3.isTemplateEntityV1beta3;
exports.templateEntityV1beta3Validator = TemplateEntityV1beta3.templateEntityV1beta3Validator;
exports.ScaffolderClient = ScaffolderClient.ScaffolderClient;
//# sourceMappingURL=index.cjs.js.map
